<h4 class="ds-heading-2" [class.ds-color-error]="hasError">
  <app-ds-icon *ngIf="!!hint" class="info-icon" (click)="toggleHint()" name="info" color="var(--color-core-neutral-5)" />
  {{ title }}
</h4>
<div *ngIf="showHint" class="info-hint">
  <p class="ds-ui-3 ds-color-core-neutral-7">{{ hint }}</p>
</div>
<div class="question-row" [class.chips]="chips">
  <ng-container *ngFor="let option of options">
    @if (chips) {
      <app-ds-chip [active]="value === option.id" [value]="option.id" (check)="onOptionChange($event)">
        {{ option.option_text }}
      </app-ds-chip>
    } @else {
      <app-ds-radio-option [value]="option.id" [selected]="value" (clicked)="onOptionChange($event)" type="basic">
        <ng-container ds-radio-title>{{ option.option_text }}</ng-container>
      </app-ds-radio-option>
    }
  </ng-container>
</div>
